import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { AuthProvider } from '@gumahub/authentication';
import { ThemeProvider } from './contexts/ThemeContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { I18nLoader } from './components/I18nLoader';
import App from './App';
import './styles/index.css';

// CRITICAL: Initialize i18n FIRST before anything else
import i18n from './i18n';

// Ensure i18n is ready
if (!i18n.isInitialized) {
  console.warn('⚠️  i18n not initialized immediately, waiting...');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <I18nLoader>
        <BrowserRouter>
          <ThemeProvider>
            <BrandingProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </BrandingProvider>
          </ThemeProvider>
        </BrowserRouter>
      </I18nLoader>
    </I18nextProvider>
  </React.StrictMode>
);
